module.exports = __webpack_public_path__ + "img/img_index_thumb_sms_intro_4.c63f7eec.jpg";